var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('report-viewer',{attrs:{"report-name":"Redpath Daily Report Portrait v0.2 (SQL)"}})}
var staticRenderFns = []

export { render, staticRenderFns }